// src/api/service/user/purchases.service.ts
import { apiClient } from "../config";
import { env } from "../../config/env";
import {
    DigitalProductsResponse,
    PhysicalProductsResponse,
    TransactionsResponse,
    ProductResourcesResponse,
    DashboardResponse, // 👈 NOUVEAU
} from "../interface/purchases.interface";

class UserPurchasesService {
    /**
     * 📊 Tableau de bord utilisateur
     */
    async getDashboard(): Promise<DashboardResponse> {
        const response = await apiClient.get<DashboardResponse>(
            env.USER_PURCHASES.DASHBOARD
        );
        return response.data;
    }

    /**
     * 📦 Produits digitaux achetés
     */
    async getDigitalProducts(): Promise<DigitalProductsResponse> {
        const response = await apiClient.get<DigitalProductsResponse>(
            env.USER_PURCHASES.DIGITAL
        );
        return response.data;
    }

    /**
     * 📦 Produits physiques achetés
     */
    async getPhysicalProducts(): Promise<PhysicalProductsResponse> {
        const response = await apiClient.get<PhysicalProductsResponse>(
            env.USER_PURCHASES.PHYSICAL
        );
        return response.data;
    }

    /**
     * 💳 Transactions de paiement
     */
    async getTransactions(): Promise<TransactionsResponse> {
        const response = await apiClient.get<TransactionsResponse>(
            env.USER_PURCHASES.TRANSACTIONS
        );
        return response.data;
    }

    /**
     * 📄 Ressources d'un produit digital acheté
     */
    async getProductResources(productId: string): Promise<ProductResourcesResponse> {
        const response = await apiClient.get<ProductResourcesResponse>(
            env.USER_PURCHASES.PRODUCT_RESOURCES(productId)
        );
        return response.data;
    }

    /**
     * ⬇️ Télécharger une ressource (fichier)
     * Retourne un Blob pour le téléchargement
     */
    async downloadResource(productId: string, resourceId: string): Promise<Blob> {
        const response = await apiClient.get(
            env.USER_PURCHASES.DOWNLOAD_RESOURCE(productId, resourceId),
            {
                responseType: 'blob',
            }
        );
        return response.data;
    }
}

export const userPurchasesService = new UserPurchasesService();